import React from 'react';
import { LayoutSingleColumn, Page } from '../../components';
import { useSelector } from 'react-redux';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { useIntl } from 'react-intl';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';

import css from './ArtistHelpPage.module.css';
import SectionHero from './SectionHero/SectionHero';
import SectionBenefits from './SectionBenefits/SectionBenefits';
import SectionHowItWorks from './SectionHowItWorks/SectionHowItWorks';
import SectionKnowMore from './SectionKnowMore/SectionKnowMore';
import { useConfiguration } from '../../context/configurationContext';

const ArtistHelpPage = props => {
  const state = useSelector(state => state);
  const intl = useIntl();
  const config = useConfiguration();

  const scrollingDisabled = isScrollingDisabled(state);

  const title = intl.formatMessage({ id: 'General.artistSignup' }) + ' | ' + config.marketplaceName;
  const desc = intl.formatMessage({ id: 'ArtistHelpPage.desc' });

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      openGraphType="website"
      description={desc}
      title={title}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: desc,
        name: title,
      }}
    >
      <LayoutSingleColumn
        topbar={<TopbarContainer currentPage="ArtistHelpPage" />}
        footer={<FooterContainer />}
      >
        <div className={css.container}>
          <div>
            <SectionHero className={css.hero} />
          </div>
          <ul className={css.sections}>
            <li className={css.section}>
              <SectionBenefits className={css.sectionRoot} />
            </li>
            <li className={css.section}>
              <SectionHowItWorks className={css.sectionRoot} />
            </li>
            <li className={css.section}>
              <SectionKnowMore className={css.sectionRoot} />
            </li>
          </ul>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

export default ArtistHelpPage;
